<template>
<div class="header" v-if="!hideHeader">
  <b-navbar toggleable="md" type="dark" variant="info">
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <b-navbar-brand>ランドマーク登録アプリ</b-navbar-brand>
    <b-collapse is-nav id="nav_collapse">
      <b-navbar-nav>
        <li class="nav-item" :class="{active: routeName === 'shutokou-kiloposts'}">
          <router-link :to="{name:'shutokou-kiloposts'}" class="nav-link">
            STK
          </router-link>
        </li>
        <li class="nav-item" :class="{active: routeName === 'hokuriku-kiloposts'}">
          <router-link :to="{name:'hokuriku-kiloposts'}" class="nav-link">
            NGT
          </router-link>
        </li>
        <li class="nav-item" :class="{active: routeName === 'nce-kiloposts'}">
          <router-link :to="{name:'nce-kiloposts'}" class="nav-link">
            NCE
          </router-link>
        </li>
        <li class="nav-item" :class="{active: routeName === 'arc-kiloposts'}">
          <router-link :to="{name:'arc-kiloposts'}" class="nav-link">
            ARC
          </router-link>
        </li>
        <li class="nav-item" :class="{active: routeName === 'ngy-kiloposts'}">
          <router-link :to="{name:'ngy-kiloposts'}" class="nav-link">
            NGY
          </router-link>
        </li>
        <li class="nav-item" :class="{active: routeName === 'fukuoka-kitakyushu-kiloposts'}">
          <router-link :to="{name:'fukuoka-kitakyushu-kiloposts'}" class="nav-link">
            福岡北九州
          </router-link>
        </li>
        <li class="nav-item" :class="{active: routeName === 'honshi-kiloposts'}">
          <router-link :to="{name:'honshi-kiloposts'}" class="nav-link">
            本四高速
          </router-link>
        </li>
        <li class="nav-item" :class="{active: routeName === 'hitachi-kasen-kiloposts'}">
          <router-link :to="{name:'hitachi-kasen-kiloposts'}" class="nav-link">
            常陸河川
          </router-link>
        </li>
        <li class="nav-item" :class="{active: routeName === 'koufu-kasen-kiloposts'}">
          <router-link :to="{name:'koufu-kasen-kiloposts'}" class="nav-link">
            甲府河川
          </router-link>
        </li>
        <li class="nav-item" :class="{active: routeName === 'miyagi-kiloposts'}">
          <router-link :to="{name:'miyagi-kiloposts'}" class="nav-link">
            宮城県
          </router-link>
        </li>
        <li class="nav-item" :class="{active: routeName === 'tokyu-kiloposts'}">
          <router-link :to="{name:'tokyu-kiloposts'}" class="nav-link">
            東急
          </router-link>
        </li>
        <li class="nav-item" :class="{active: routeName === 'iwaki-kiloposts'}">
          <router-link :to="{name:'iwaki-kiloposts'}" class="nav-link">
            いわき市
          </router-link>
        </li>
        <li class="nav-item" :class="{active: routeName === 'yurikamome-kiloposts'}">
          <router-link :to="{name:'yurikamome-kiloposts'}" class="nav-link">
            ゆりかもめ
          </router-link>
        </li>
        <li class="nav-item" :class="{active: routeName === 'gunma-kiloposts'}">
          <router-link :to="{name:'gunma-kiloposts'}" class="nav-link">
            群馬県
          </router-link>
        </li>
        <li class="nav-item" :class="{active: routeName === 'kantou-mc-kiloposts'}">
          <router-link :to="{name:'kantou-mc-kiloposts'}" class="nav-link">
            関東MC
          </router-link>
        </li>
        <li class="nav-item" :class="{active: routeName === 'nagano-kiloposts'}">
          <router-link :to="{name:'nagano-kiloposts'}" class="nav-link">
            長野国道
          </router-link>
        </li>
        <li class="nav-item dropdown" :class="{active: isNexcoPageGroup}">
          <a class="nav-link dropdown-toggle" data-toggle="dropdown"
              href="#" role="button" aria-haspopup="true"
              aria-expanded="false">NEXCO</a>
          <div class="dropdown-menu">
            <router-link :to="{
                name:'nexco-east-niigata-kiloposts'
              }" class="dropdown-item" @click.native="onDropdownMenuClick">
              NEXCO東 メンテ新潟
            </router-link>
            <router-link :to="{
                name:'nexco-east-saitama-kiloposts'
              }" class="dropdown-item" @click.native="onDropdownMenuClick">
              NEXCO東 東エンジ
            </router-link>
            <router-link :to="{
                name:'shikoku-kiloposts'
              }" class="dropdown-item" @click.native="onDropdownMenuClick">
              NEXCO西 四国エンジ
            </router-link>
          </div>
        </li>
        <li class="nav-item dropdown" :class="{active: routeName === 'chisei-kiloposts'}">
          <a class="nav-link dropdown-toggle" data-toggle="dropdown"
              href="#" role="button" aria-haspopup="true"
              aria-expanded="false">地整</a>
          <div class="dropdown-menu">
            <router-link :to="{
                name: 'chisei-kiloposts',
                params: { chisei: 'touhoku' }
              }" class="dropdown-item" @click.native="onDropdownMenuClick">
              東北地整(thr)
            </router-link>
            <router-link :to="{
                name: 'chisei-kiloposts',
                params: { chisei: 'kantou' }
              }" class="dropdown-item" @click.native="onDropdownMenuClick">
              関東地整(ktr)
            </router-link>
            <router-link :to="{
                name: 'chisei-kiloposts',
                params: { chisei: 'hokuriku' }
              }" class="dropdown-item" @click.native="onDropdownMenuClick">
              北陸地整(hrr)
            </router-link>
            <router-link :to="{
                name: 'chisei-kiloposts',
                params: { chisei: 'chubu' }
              }" class="dropdown-item" @click.native="onDropdownMenuClick">
              中部地整(cbr)
            </router-link>
            <router-link :to="{
                name: 'chisei-kiloposts',
                params: { chisei: 'kinki' }
              }" class="dropdown-item" @click.native="onDropdownMenuClick">
              近畿地整(kkr)
            </router-link>
            <router-link :to="{
                name: 'chisei-kiloposts',
                params: { chisei: 'chugoku' }
              }" class="dropdown-item" @click.native="onDropdownMenuClick">
              中国地整(cgr)
            </router-link>
            <router-link :to="{
                name: 'chisei-kiloposts',
                params: { chisei: 'shikoku' }
              }" class="dropdown-item" @click.native="onDropdownMenuClick">
              四国地整(skr)
            </router-link>
          </div>
        </li>
        <li class="nav-item dropdown" :class="{active: routeName === 'kendo-kiloposts'}">
          <a class="nav-link dropdown-toggle" data-toggle="dropdown"
              href="#" role="button" aria-haspopup="true"
              aria-expanded="false">県土</a>
          <div class="dropdown-menu">
            <router-link :to="{
                name: 'kendo-kiloposts',
                params: { kendo: 'saitama' }
              }" class="dropdown-item" @click.native="onDropdownMenuClick">
              埼玉県
            </router-link>
          </div>
        </li>
        <li class="nav-item dropdown" :class="{active: isAirportPageGroup}">
          <a class="nav-link dropdown-toggle" data-toggle="dropdown"
              href="#" role="button" aria-haspopup="true"
              aria-expanded="false">空港</a>
          <div class="dropdown-menu">
            <router-link :to="{
                name:'hiroshima-airport-kiloposts'
              }" class="dropdown-item" @click.native="onDropdownMenuClick">
              広島空港
            </router-link>
            <router-link :to="{
                name:'shinchitose-airport-kiloposts'
              }" class="dropdown-item" @click.native="onDropdownMenuClick">
              新千歳空港
            </router-link>
          </div>
        </li>
        <li class="nav-item" :class="{active: routeName === 'joint-touroku'}">
          <router-link :to="{name:'joint-touroku'}" class="nav-link">
            Joints
          </router-link>
        </li>
        <li class="nav-item" :class="{active: routeName === 'pole-touroku'}">
          <router-link :to="{name:'pole-touroku'}" class="nav-link">
            Poles
          </router-link>
        </li>
      </b-navbar-nav>
      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-text class="mr8">{{username}}さん</b-nav-text>
        <b-nav-item @click="logout">ログアウト</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</div>
</template>

<script>
import { mapState } from 'vuex'
import userApi from '@/api/user'

export default {
  name: 'global-header',
  data() {
    return {}
  },
  computed: {
    ...mapState('user', {
      username: state => state.username,
    }),
    routeName() {
      return this.$route.name
    },
    hideHeader() {
      const arr = ['login']
      return arr.indexOf(this.$route.name) !== -1
    },
    isNexcoPageGroup() {
      return [
        'nexco-east-niigata-kiloposts',
        'nexco-east-saitama-kiloposts',
        'shikoku-kiloposts',
      ].includes(this.$route.name)
    },
    isAirportPageGroup() {
      return [
        'hiroshima-airport-kiloposts',
        'shinchitose-airport-kiloposts',
      ].includes(this.$route.name)
    },
  },
  methods: {
    onDropdownMenuClick(evt) {
      $(evt.target).parents('.dropdown-menu').removeClass('show')
    },
    logout() {
      userApi.logout().then(() => {
        location.href = '/login'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-item {
  white-space: nowrap;

  &.active .nav-link {
    font-size: 20px;
    padding: 0.3rem 0.5rem;
  }
}
</style>
